import { render, staticRenderFns } from "./RichScan.vue?vue&type=template&id=11869108&scoped=true&"
import script from "./RichScan.vue?vue&type=script&lang=js&"
export * from "./RichScan.vue?vue&type=script&lang=js&"
import style0 from "./RichScan.vue?vue&type=style&index=0&id=11869108&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11869108",
  null
  
)

export default component.exports